import { consoleEvents } from '@pb/utils'
import { createReducer } from 'redux-act'

import { EsalesPanelStructure, PraState } from '../types'
import * as actions from './actions'
import initialState from './initialState'

const fetchCartPraStart = (state: PraState): PraState => ({
  ...state,
  isLoading: true,
})

const fetchCartPraSuccess = (state: PraState, praData: EsalesPanelStructure): PraState => ({
  ...state,
  praData,
  isLoading: false,
  isPopulated: true,
})

const fetchCartPraFail = (state: PraState, error: Error): PraState => {
  consoleEvents.error('Failed to fetch cart PRA', error)

  return {
    ...state,
    isLoading: false,
    isLoadingFailed: true,
  }
}

const reducer = createReducer((on) => {
  on(actions.fetchCartPraStart, fetchCartPraStart)
  on(actions.fetchCartPraSuccess, fetchCartPraSuccess)
  on(actions.fetchCartPraFail, fetchCartPraFail)
}, initialState)

export default reducer
